import "./index.scss";
import Logo_S from "../../assets/images/Logo_S.png";
import Logo_A from "../../assets/images/Logo_A.png";
import { Link, NavLink } from "react-router-dom";
import { BiHomeSmile, BiUser } from "react-icons/bi";
import { VscTools } from "react-icons/vsc";
import { RiProjector2Line } from "react-icons/ri";
import { MdWorkOutline } from "react-icons/md";
import { AiOutlineLinkedin } from "react-icons/ai";
import { FiGithub, FiMail } from "react-icons/fi";

const Sidebar = () => {

  return (
    <div className="nav-bar">
      <Link className="logo" to={"/"}>
        <img src={Logo_S} alt="logo-s" />
        <img src={Logo_A} alt="logo-a" />
      </Link>
      <nav>
        <NavLink exact = "true" activeclassname = "active" to = "/">
          <BiHomeSmile className="nav-bar-icons" />
        </NavLink>
        <NavLink exact = "true" activeclassname = "active" className={`about-link`} to = "about">
          <BiUser className="nav-bar-icons" />
        </NavLink>
        <NavLink exact = "true" activeclassname = "active" className={`skills-link`} to = "skills">
          <VscTools className="nav-bar-icons" />
        </NavLink>
        <NavLink exact = "true" activeclassname = "active" className={`projects-link`} to = "projects">
          <RiProjector2Line className="nav-bar-icons" />
        </NavLink>
      </nav>
      <ul>
        <li>
          <a target = "_blank" rel = "noreferrer" href = "https://www.linkedin.com/in/shubh-ashish-a4a415190/">
            <AiOutlineLinkedin />
          </a>
        </li>
        <li>
          <a target = "_blank" rel = "noreferrer" href = "https://github.com/solarconstant">
            <FiGithub />
          </a>
        </li>
        <li>
          <a target = "_blank" rel = "noreferrer" href = "mailto:ashishshubh001@gmail.com">
            <FiMail />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
